// extracted by mini-css-extract-plugin
export default {"faqBlock":"FAQPage_faqBlock__jSQgR","shell":"FAQPage_shell__fqIRW","askBox":"FAQPage_askBox__F+Ka9","askBtn":"FAQPage_askBtn__ReSvI"};